import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";

export type GetLomdaV2ResponseType = InferResponseType<
    (typeof client.api.storage)["lomda-v2"][":lomdaId"]["$get"],
    200
>;

export const useGetLomdaV2 = (enabled: boolean, lomdaId: string) => {
    const query = useQuery({
        enabled,
        queryKey: ["get-lomda-v2", lomdaId],
        queryFn: async () => {
            const response = await client.api.storage["lomda-v2"][":lomdaId"].$get(
                { param: { lomdaId } }
            );

            if (!response.ok) throw new Error("Failed to fetch lomdaV2");

            const { data } = await response.json();
            return { data };
        },
    });

    return query;
};
